<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,0.57C16,0.26,15.79,0,15.48,0L8.57,0C8.26,0,8,0.26,8,0.57C8,0.73,8.06,0.87,8.17,0.98L11,3.71L11,7.45C11,7.76,11.26,8.02,11.57,8.02C11.73,8.02,11.88,7.95,11.98,7.85L12.8,6.75C12.91,6.64,12.97,6.5,12.97,6.34L12.97,3.71L15.83,0.98C15.94,0.87,16,0.73,16,0.57ZM13,10L7,10L7,8L9,8L9,7L7,7L7,5L9,5L9,4.3L5.33333,1L1,1C0.4,1,0,1.5,0,2L0,14C0,14.6,0.4,15,1,15L15,15C15.6,15,16,14.6,16,14L16,3.4L15,4.29999L15,7.14922C15,7.37629,14.9227,7.5966,14.7809,7.77391L13,10ZM6,5L6,7L2,7L2,5L6,5ZM6,10L6,8L2,8L2,10L6,10ZM6,11L6,13L2,13L2,11L6,11ZM14,13L14,11L7,11L7,13L14,13Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ThFiltered',
} as DefineComponent
</script>
